import { Link } from 'react-router-dom';

export const Brand = ({ dark = false }) => (
  <Link to="/" className={`brand brand-img ${dark ? 'brand-dark' : ''}`}>
    <img
      src="/assets/Logo.png"
      alt="Pass’io"
      className="brand-logo"
      style={dark ? { filter: 'brightness(0) invert(1)' } : undefined}
    />
    <small>for Artists</small>
  </Link>
);

export default Brand;
